import { InjectionToken } from '@angular/core';

export const WEB_APP_API_BASE_URL = new InjectionToken<string>('Web App API Base URL');
